import { isAxiosError } from 'axios'

import httpClient from '../../httpClient.ts'
import { PricesList, PricingData, PricingResponse } from './types.ts'

const getPricing = async () => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.get<PricingResponse<PricingData>>(
      '/api/dd_panel_pricing/get_pricing/'
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse as PricingResponse<PricingData>
}

const setPricing = async (newPricingData: PricesList) => {
  let fetchResponse = {
    data: {},
    status: 200,
    error: null
  }
  try {
    const response = await httpClient.post(
      '/api/dd_panel_pricing/set_pricing/',
      newPricingData
    )
    fetchResponse.data = response.data
    fetchResponse.status = response.status
  } catch (error) {
    if (isAxiosError(error)) {
      fetchResponse.error = error.response?.data.error_code
      fetchResponse.status = error.response?.status as number
    }
  }
  return fetchResponse as PricingResponse<PricingData>
}

export const pricingAPI = {
  getPricing,
  setPricing
}
